import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=7b628de0&scoped=true&"
import script from "./OrderCard.vue?vue&type=script&lang=js&"
export * from "./OrderCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=7b628de0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b628de0",
  null
  
)

export default component.exports